"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class VerifyOrgInvite extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'verifyOrgInvite';
        this._code = initParams.code;
        this._organisationName = initParams.organisation_name;
        this._emailAddress = initParams.email_address;
        this._status = initParams.status;
        this._orgPermission = initParams.org_permission;
        this._logoImageThumbnail = initParams.logo_image_thumbnail;
        this._squareLogoImageThumbnail = initParams.square_logo_image_thumbnail;
    }
    set code(value) {
        console.error('Do not set objects this way');
    }
    get code() {
        return this._code;
    }
    set organisationName(value) {
        console.error('Do not set objects this way');
    }
    get organisationName() {
        return this._organisationName;
    }
    set emailAddress(value) {
        console.error('Do not set objects this way');
    }
    get emailAddress() {
        return this._emailAddress;
    }
    set status(value) {
        console.error('Do not set objects this way');
    }
    get status() {
        return this._status;
    }
    set orgPermission(value) {
        console.error('Do not set objects this way');
    }
    get orgPermission() {
        return this._orgPermission;
    }
    set logoImageThumbnail(value) {
        console.error('Do not set objects this way');
    }
    get logoImageThumbnail() {
        return this._logoImageThumbnail;
    }
    set squareLogoImageThumbnail(value) {
        console.error('Do not set objects this way');
    }
    get squareLogoImageThumbnail() {
        return this._squareLogoImageThumbnail;
    }
}
exports.default = VerifyOrgInvite;
//# sourceMappingURL=verifyOrgInvite.js.map